{
  "health": {
    "ON_TRACK": "ضمن المسار",
    "AT_RISK": "معرّض للخطر",
    "OFF_TRACK": "خارج المسار",
    "NOT_MEASURED": "غير مُقاس",
    "trigger": "سلامة المشروع: {{level}}. لماذا؟",
    "whyTitle": "لماذا المشروع {{level}}",
    "rule": "السلامة العامة هي الأسوأ بين التكلفة والجدول الزمني والفوترة والعقد. أما التنفيذ وتنظيم السجلات فأقصى ما يبلغانه «معرّض للخطر».",
    "notMeasured": {
      "NO_BUDGET": "لا يُقاس قبل اعتماد موازنة.",
      "NO_DATES": "لا يُقاس قبل تحديد تواريخ الخطة.",
      "NOT_ACTIVE": "يُقاس فقط والمشروع نشط."
    },
    "stillListed": "تبقى التنبيهات ظاهرة في «تحتاج إلى متابعة».",
    "dimension": {
      "cost": "التكلفة",
      "schedule": "الجدول الزمني",
      "billing": "الفوترة والتحصيل",
      "contract": "العقد",
      "delivery": "التنفيذ",
      "hygiene": "تنظيم السجلات"
    },
    "level": {
      "none": "سليم",
      "info": "ملاحظة",
      "warning": "تحذير",
      "critical": "حرج"
    },
    "hidden": "الاطلاع على الأسباب يحتاج إلى صلاحية أموال المشروع.",
    "asOf": "آخر فحص {{date}}"
  },
  "attention": {
    "since": "منذ {{date}}",
    "failed": "تعذّر فحص التنبيهات، لذا تظهر تواريخ الخطة فقط."
  },
  "alerts": {
    "label": "تنبيهات المشروع",
    "seeAll": "عرض الكل في «تحتاج إلى متابعة»",
    "count_zero": "لا توجد تنبيهات",
    "count_one": "تنبيه واحد",
    "count_two": "تنبيهان",
    "count_few": "{{n}} تنبيهات",
    "count_many": "{{n}} تنبيهًا",
    "count_other": "{{n}} تنبيه",
    "seeAllShort": "عرض الكل"
  },
  "units": {
    "workingDays_zero": "{{n}} يوم عمل",
    "workingDays_one": "يوم عمل واحد",
    "workingDays_two": "يوما عمل",
    "workingDays_few": "{{n}} أيام عمل",
    "workingDays_many": "{{n}} يوم عمل",
    "workingDays_other": "{{n}} يوم عمل",
    "days_zero": "{{n}} يوم",
    "days_one": "يوم واحد",
    "days_two": "يومان",
    "days_few": "{{n}} أيام",
    "days_many": "{{n}} يومًا",
    "days_other": "{{n}} يوم",
    "points_zero": "{{n}} نقطة",
    "points_one": "نقطة واحدة",
    "points_two": "نقطتان",
    "points_few": "{{n}} نقاط",
    "points_many": "{{n}} نقطة",
    "points_other": "{{n}} نقطة",
    "invoices_zero": "{{n}} فاتورة",
    "invoices_one": "فاتورة واحدة",
    "invoices_two": "فاتورتان",
    "invoices_few": "{{n}} فواتير",
    "invoices_many": "{{n}} فاتورة",
    "invoices_other": "{{n}} فاتورة",
    "tasks_zero": "{{n}} مهمة",
    "tasks_one": "مهمة واحدة",
    "tasks_two": "مهمتان",
    "tasks_few": "{{n}} مهام",
    "tasks_many": "{{n}} مهمة",
    "tasks_other": "{{n}} مهمة",
    "blockedTasks_zero": "{{n}} مهمة متعثرة",
    "blockedTasks_one": "مهمة واحدة متعثرة",
    "blockedTasks_two": "مهمتان متعثرتان",
    "blockedTasks_few": "{{n}} مهام متعثرة",
    "blockedTasks_many": "{{n}} مهمة متعثرة",
    "blockedTasks_other": "{{n}} مهمة متعثرة",
    "overdueTasks_zero": "{{n}} مهمة متأخرة",
    "overdueTasks_one": "مهمة واحدة متأخرة",
    "overdueTasks_two": "مهمتان متأخرتان",
    "overdueTasks_few": "{{n}} مهام متأخرة",
    "overdueTasks_many": "{{n}} مهمة متأخرة",
    "overdueTasks_other": "{{n}} مهمة متأخرة",
    "documents_zero": "{{n}} مستند",
    "documents_one": "مستند واحد",
    "documents_two": "مستندان",
    "documents_few": "{{n}} مستندات",
    "documents_many": "{{n}} مستندًا",
    "documents_other": "{{n}} مستند",
    "hours_zero": "{{n}} ساعة",
    "hours_one": "ساعة واحدة",
    "hours_two": "ساعتان",
    "hours_few": "{{n}} ساعات",
    "hours_many": "{{n}} ساعة",
    "hours_other": "{{n}} ساعة",
    "hoursNote": " وتشمل {{hours}} من ساعات العمل."
  },
  "signal": {
    "BURN_AHEAD": {
      "title": "الصرف يسبق الإنجاز بـ {{gapPts}}",
      "detail": "صُرف {{spentPct}}% من الموازنة مقابل إنجاز {{progressPct}}% من العمل.",
      "action": "عرض التكاليف",
      "short": "الإنفاق يسبق الإنجاز"
    },
    "BUDGET_EXCEEDED": {
      "title": "تجاوز الموازنة بنسبة {{overPct}}%",
      "detail": "المصروف {{ac}} مقابل موازنة قدرها {{bac}}.",
      "action": "نسخة موازنة جديدة",
      "short": "تجاوز الموازنة"
    },
    "CATEGORY_EXCEEDED": {
      "title": "فئة {{category}} قاربت موازنتها أو تجاوزتها",
      "detail": "المصروف {{actual}} والملتزم به في أوامر الشراء {{committed}} مقابل موازنة قدرها {{budget}}.",
      "action": "عرض الفئة",
      "titleOver": "فئة {{category}} تجاوزت موازنتها، عند {{pct}}",
      "titleNear": "فئة {{category}} قاربت موازنتها، عند {{pct}}",
      "detailNoOrders": "المصروف {{actual}} مقابل موازنة قدرها {{budget}}.",
      "short": "فئة تكلفة تجاوزت موازنتها"
    },
    "FORECAST_LOSS": {
      "title": "المشروع متجه إلى خسارة قدرها {{loss}}",
      "detail": "التكلفة النهائية المتوقعة {{eac}} تزيد على الإيراد المتوقع {{rac}}.",
      "action": "عرض التوقعات",
      "short": "متجه نحو خسارة"
    },
    "MARGIN_EROSION": {
      "title": "هامش الربح يتراجع إلى {{forecastPct}}%",
      "detail": "خطّطت الموازنة لهامش {{baselinePct}}%، وبالوتيرة الحالية سيصبح {{forecastPct}}%.",
      "action": "عرض التكاليف",
      "short": "هامش الربح يتقلص"
    },
    "MILESTONE_OVERDUE": {
      "title": "«{{milestone}}» متأخر {{daysLate}}",
      "detail": "كان مخططًا له في {{plannedOn}} ولم يتحقق بعد.",
      "action": "فتح في الخطة",
      "short": "معلم رئيسي متأخر"
    },
    "SCHEDULE_SLIP": {
      "title": "موعد الإنجاز يتأخر {{slipDays}}",
      "detail": "يُتوقع الانتهاء في {{forecastOn}} بدلًا من {{plannedOn}}، والعمل يسير بنسبة {{spiT}} من الوتيرة المخططة.",
      "action": "فتح الخطة",
      "short": "موعد الانتهاء يتأخر"
    },
    "MILESTONE_UNBILLED": {
      "title": "«{{milestone}}» أُنجز ولم يُفوتر",
      "detail": "تحقق في {{doneOn}}، ومبلغ {{amount}} جاهز للفوترة.",
      "action": "فوترة المعلم",
      "short": "منجز ولم يُفوتر"
    },
    "TM_UNBILLED": {
      "title": "أعمال قابلة للفوترة بقيمة {{amount}} لم تُفوتر",
      "detail": "أقدمها بتاريخ {{oldestOn}}.{{hours}}",
      "action": "فوترة الأعمال",
      "short": "عمل قابل للفوترة ينتظر"
    },
    "RECEIVABLE_OVERDUE": {
      "title": "مبلغ {{amount}} متأخر السداد على العميل",
      "detail": "{{count}} تجاوزت تاريخ الاستحقاق، أقدمها بـ {{maxDays}}.",
      "action": "عرض الفواتير",
      "short": "العميل متأخر في السداد"
    },
    "PROJECT_STALE": {
      "title": "لا نشاط منذ {{days}}",
      "detail": "لم يُسجَّل شيء منذ {{lastActivityOn}}: لا إنجاز ولا تكاليف ولا مهام.",
      "action": "تحديث الإنجاز",
      "short": "لا نشاط حديث"
    },
    "TASKS_BLOCKED": {
      "title": "{{count}}",
      "detail": "أقدمها متعثرة، ومدة تعثّرها {{oldestDays}}.",
      "action": "عرض المهام",
      "short": "مهام متعثرة"
    },
    "TASKS_OVERDUE": {
      "title": "{{count}}",
      "detail": "أقدمها تجاوزت موعد استحقاقها بـ {{oldestDays}}.",
      "action": "عرض المهام",
      "short": "مهام متأخرة"
    },
    "UNASSIGNED_COSTS": {
      "title": "مبلغ {{amount}} قد يخص هذا المشروع",
      "detail": "بلا مشروع: {{count}} من عميل المشروع أو مورديه، بتاريخ يقع ضمن فترة المشروع.",
      "action": "مراجعة التكاليف",
      "short": "مستندات بلا مشروع"
    },
    "NO_APPROVED_BUDGET": {
      "title": "لا توجد موازنة معتمدة",
      "detail": "اعتمد موازنة لقياس التكلفة والإنجاز مقابلها.",
      "action": "فتح الموازنة",
      "short": "لا موازنة معتمدة"
    },
    "TIME_NOT_SUBMITTED": {
      "title": "{{member}} لم يُرسل وقت الأسبوع الماضي",
      "detail": "أُرسل {{submitted}} من أصل {{expected}} متوقعة لأسبوع {{weekStart}}.",
      "action": "فتح تبويب الوقت",
      "short": "وقت لم يُرسَل"
    },
    "RETENTION_DUE": {
      "title": "محتجزات بقيمة {{amount}} مستحقة الإفراج",
      "detail": "موعد الإفراج {{dueOn}}، ولم تصدر فاتورة الإفراج بعد.",
      "action": "الإفراج عن المحتجزات",
      "titleSoon": "يحين الإفراج عن محتجزات بقيمة {{amount}} في {{dueOn}}",
      "short": "محتجزات مستحقة"
    },
    "BOND_EXPIRING": {
      "title": "{{bondType}} رقم {{ref}} ينتهي في {{expiresOn}}",
      "detail": "اطلب من البنك تمديده، أو اطلب الإفراج عنه، قبل انتهائه.",
      "action": "فتح الضمانات",
      "titleExpired": "{{bondType}} رقم {{ref}} انتهى في {{expiresOn}}",
      "detailExpired": "لم يعد يغطي العقد: مدّده أو سجّل الإفراج عنه.",
      "short": "ضمان يقترب من الانتهاء"
    },
    "CLAIM_NOT_CERTIFIED": {
      "title": "المستخلص {{claim}} لم يُعتمد بعد {{days}}",
      "detail": "قُدّم في {{submittedOn}} بمبلغ {{amount}}.",
      "action": "تسجيل الاعتماد",
      "short": "مستخلص لم يُعتمد"
    },
    "VARIATION_PENDING": {
      "title": "الأمر التغييري {{variation}} بانتظار قرار العميل منذ {{days}}",
      "detail": "أمر تغييري بقيمة {{amount}} لم يُبتّ فيه بعد.",
      "action": "فتح الأمر التغييري",
      "short": "أمر تغييري معلّق"
    },
    "ADVANCE_RECOVERY_BEHIND": {
      "title": "استرداد الدفعة المقدمة متأخر عن الإنجاز",
      "detail": "استُرد {{recoveredPct}}% من الدفعة المقدمة عند إنجاز {{progressPct}}%، ويبقى {{outstanding}} للاسترداد.",
      "action": "فتح المحتجزات والدفعة المقدمة",
      "short": "استرداد الدفعة المقدمة متأخر"
    }
  },
  "forecast": {
    "title": "التوقعات بالكلمات",
    "datesOnly": "التواريخ فقط: توقعات المبالغ تحتاج إلى صلاحية أموال المشروع.",
    "tooEarly": "من المبكر توقع التكلفة: أُنجز {{progress}} من العمل وصُرف {{spent}} من الموازنة، وتبدأ توقعات التكلفة حين يبلغ كلاهما {{min}}. وحتى ذلك الحين تساوي التكلفة النهائية المتوقعة الموازنة.",
    "notEnough": "البيانات غير كافية بعد.",
    "notMeasured": {
      "NO_BUDGET": "تبدأ التوقعات بعد اعتماد موازنة.",
      "NO_DATES": "تبدأ التوقعات بعد تحديد تواريخ الخطة.",
      "NOT_ACTIVE": "تبدأ التوقعات عندما يصبح المشروع نشطًا."
    },
    "how": "كيف يُحسب هذا؟",
    "efficiency": {
      "label": "العمل مقابل المال",
      "tooEarly": "من المبكر الحكم: انتظر حتى يبلغ كلٌّ من العمل المنجز والموازنة المصروفة {{min}}.",
      "text": "مقابل كل {{spent}} مصروفة، أُنجز عمل بقيمة {{earned}}.",
      "how": "العمل المنجز = الإنجاز ({{progress}}) × الموازنة ({{bac}}) = {{ev}}. المصروف حتى الآن {{ac}}. العمل المنجز ÷ المصروف = {{ratio}}."
    },
    "schedule": {
      "label": "مقارنة بالخطة",
      "behind": "متأخر عن الخطة {{days}}.",
      "ahead": "متقدم على الخطة {{days}}.",
      "onPlan": "وفق الخطة.",
      "how": "موعد الانتهاء المتوقع ({{forecast}}) مقارنة بالموعد المخطط ({{planned}})، محسوبًا بأيام العمل في تقويم الشركة."
    },
    "finalCost": {
      "label": "التكلفة النهائية المتوقعة",
      "over": "التكلفة النهائية المتوقعة {{eac}} (تزيد على الموازنة بـ {{diff}}).",
      "under": "التكلفة النهائية المتوقعة {{eac}} (أقل من الموازنة بـ {{diff}}).",
      "onBudget": "التكلفة النهائية المتوقعة {{eac}}، مطابقة للموازنة.",
      "how": {
        "CPI": "الموازنة {{bac}} ÷ كفاءة التكلفة {{cpi}} (القيمة المكتسبة لكل ريال مصروف). يفترض أن بقية العمل ستكلف بالمعدل نفسه حتى الآن.",
        "REMAINING_AT_BUDGET": "المصروف {{ac}} + موازنة العمل المتبقي ({{bac}} − {{ev}} من العمل المنجز).",
        "CPI_SPI": "المصروف {{ac}} + العمل المتبقي ({{bac}} − {{ev}}) ÷ (كفاءة التكلفة {{cpi}} × الوتيرة {{spi}})."
      }
    },
    "finish": {
      "label": "موعد الانتهاء المتوقع",
      "text": "موعد الانتهاء المتوقع {{forecast}} (المخطط {{planned}}).",
      "noPlan": "لا يوجد موعد انتهاء مخطط بعد.",
      "none": "لا يوجد موعد انتهاء متوقع بعد: لم يُنجز عمل في الفترة الأخيرة.",
      "how": "أيام العمل المخططة ممتدة بحسب وتيرة العمل حتى الآن ({{pace}} من الخطة)، وفق تقويم الشركة."
    },
    "margin": {
      "label": "هامش الربح المتوقع",
      "text": "هامش الربح المتوقع {{forecast}}% (في الموازنة {{baseline}}%).",
      "how": "(الإيراد المتوقع {{rac}} − التكلفة النهائية المتوقعة {{eac}}) ÷ الإيراد المتوقع."
    },
    "expert": "مؤشرات القيمة المكتسبة",
    "metric": {
      "progressPct": "الإنجاز",
      "bac": "BAC · الموازنة عند الإنجاز",
      "pv": "PV · القيمة المخططة حتى اليوم",
      "ev": "EV · القيمة المكتسبة",
      "ac": "AC · التكلفة الفعلية",
      "cpi": "CPI · أداء التكلفة",
      "spi": "SPI · أداء الجدول",
      "spiT": "SPI(t) · أداء الجدول الزمني",
      "eac": "EAC · التقدير عند الإنجاز",
      "etc": "ETC · التقدير حتى الإنجاز",
      "vac": "VAC · الفرق عند الإنجاز",
      "eacMethod": "طريقة حساب EAC"
    },
    "eacMethod": {
      "CPI": "BAC ÷ CPI",
      "REMAINING_AT_BUDGET": "AC + (BAC − EV)",
      "CPI_SPI": "AC + (BAC − EV) ÷ (CPI × SPI)"
    },
    "failed": "تعذّر تحميل التوقع.",
    "retry": "إعادة المحاولة"
  },
  "curve": {
    "label": "منحنى التكلفة: المخطط والمكتسب والمصروف حتى الآن",
    "caption": "المخطط والمكتسب والمصروف شهريًا، تراكميًا، بالريال العماني",
    "planned": "المخطط",
    "earned": "المكتسب",
    "spent": "المصروف",
    "forecast": "المتوقع",
    "budget": "الموازنة",
    "today": "اليوم",
    "month": "الشهر",
    "empty": "يظهر المنحنى بعد اعتماد موازنة للمشروع وتحديد تواريخ الخطة.",
    "failed": "تعذّر تحميل المنحنى.",
    "how": "المخطط يوزّع موازنة كل مرحلة على أيام عملها. المكتسب = الإنجاز × الموازنة. المصروف هو التكلفة المرحّلة. الخط المتقطع يمتد من اليوم إلى التكلفة النهائية المتوقعة عند موعد الانتهاء المتوقع.",
    "weekly": "أسبوعيًا، كما سُجّل كل سبت، مع أرقام اليوم.",
    "monthly": "شهريًا، محسوبًا من أرقام اليوم. يحلّ محله السجل الأسبوعي بعد تسجيل أسبوعين.",
    "monthlyFallback": "تعذّر تحميل السجل الأسبوعي، لذا يظهر المنحنى الشهري.",
    "captionWeekly": "المخطط والمكتسب والمصروف أسبوعيًا، تراكميًا، بالريال العماني",
    "week": "الأسبوع",
    "liveRow": "اليوم، {{date}}",
    "calcChanged": "حُسبت الأرقام بطريقة مختلفة قبل {{date}}"
  },
  "week": {
    "of": "أسبوع {{day}}"
  },
  "changes": {
    "title": "ما الذي تغيّر هذا الأسبوع",
    "titleThat": "ما الذي تغيّر في ذلك الأسبوع",
    "week": "الأسبوع",
    "thisWeek": "{{week}} (هذا الأسبوع)",
    "basisLive": "أرقام اليوم مقارنةً بسجل {{date}}.",
    "basisWeek": "سجل {{to}} مقارنةً بسجل {{from}}.",
    "basisFirst": "السجل الأول، بتاريخ {{date}}.",
    "calcChanged": "تغيّرت طريقة الحساب بين السجلين، فجزء من الفرق يعود إلى المعادلات الجديدة.",
    "health": "السلامة",
    "healthWent": "تغيّرت سلامة المشروع من «{{before}}» إلى «{{after}}».",
    "healthHeld": "بقيت سلامة المشروع «{{level}}».",
    "better": "أفضل",
    "worse": "أسوأ",
    "same": "دون تغيير",
    "signals": "التنبيهات",
    "kind": {
      "new": "جديدة",
      "resolved": "زالت",
      "escalated": "تفاقمت",
      "eased": "خفّت"
    },
    "upFrom": "ارتفعت من «{{level}}»",
    "downFrom": "انخفضت من «{{level}}»",
    "figures": "الأرقام",
    "figuresCaption": "الأرقام التي تغيّرت، قبل وبعد",
    "figure": "البند",
    "before": "قبل",
    "after": "بعد",
    "change": "التغيّر",
    "label": {
      "progressPct": "الإنجاز",
      "ac": "المصروف حتى الآن",
      "committed": "الملتزم به",
      "eac": "التكلفة المتوقعة عند الإنجاز",
      "forecastMarginPct": "هامش الربح المتوقع",
      "forecastFinish": "الانتهاء المتوقع",
      "slipDays": "مقارنةً بالخطة",
      "billed": "المفوتر",
      "collected": "المحصّل"
    },
    "late_zero": "متأخر {{n}} يوم عمل",
    "late_one": "متأخر يوم عمل واحد",
    "late_two": "متأخر يومَي عمل",
    "late_few": "متأخر {{n}} أيام عمل",
    "late_many": "متأخر {{n}} يوم عمل",
    "late_other": "متأخر {{n}} يوم عمل",
    "ahead_zero": "متقدم {{n}} يوم عمل",
    "ahead_one": "متقدم يوم عمل واحد",
    "ahead_two": "متقدم يومَي عمل",
    "ahead_few": "متقدم {{n}} أيام عمل",
    "ahead_many": "متقدم {{n}} يوم عمل",
    "ahead_other": "متقدم {{n}} يوم عمل",
    "onPlan": "وفق الخطة",
    "later_zero": "تأخّر {{n}} يوم",
    "later_one": "تأخّر يومًا واحدًا",
    "later_two": "تأخّر يومين",
    "later_few": "تأخّر {{n}} أيام",
    "later_many": "تأخّر {{n}} يومًا",
    "later_other": "تأخّر {{n}} يوم",
    "earlier_zero": "تقدّم {{n}} يوم",
    "earlier_one": "تقدّم يومًا واحدًا",
    "earlier_two": "تقدّم يومين",
    "earlier_few": "تقدّم {{n}} أيام",
    "earlier_many": "تقدّم {{n}} يومًا",
    "earlier_other": "تقدّم {{n}} يوم",
    "deltaPoints_zero": "{{n}} نقطة",
    "deltaPoints_one": "{{n}} نقطة",
    "deltaPoints_two": "{{n}} نقطة",
    "deltaPoints_few": "{{n}} نقاط",
    "deltaPoints_many": "{{n}} نقطة",
    "deltaPoints_other": "{{n}} نقطة",
    "deltaWorkingDays_zero": "{{n}} يوم عمل",
    "deltaWorkingDays_one": "{{n}} يوم عمل",
    "deltaWorkingDays_two": "{{n}} يوم عمل",
    "deltaWorkingDays_few": "{{n}} أيام عمل",
    "deltaWorkingDays_many": "{{n}} يوم عمل",
    "deltaWorkingDays_other": "{{n}} يوم عمل",
    "events": "ما الذي حدث",
    "event": {
      "STATUS_CHANGED": "تغيّرت حالة المشروع إلى «{{status}}»",
      "MILESTONE_ACHIEVED": "تحقّق المعلم الرئيسي: {{label}}",
      "PROGRESS_UPDATED": "حُدّث الإنجاز: {{label}}",
      "BUDGET_APPROVED": "اعتُمدت الموازنة {{label}}",
      "VARIATION_DECIDED": "صدر قرار في الأمر التغييري {{label}}",
      "CLAIM_CERTIFIED": "اعتُمد المستخلص {{label}}",
      "INVOICE_ISSUED": "صدرت الفاتورة {{label}}",
      "TIME_APPROVED": "اعتُمدت سجلات وقت: {{label}}",
      "MEMBER_ADDED": "انضمام {{label}} إلى الفريق"
    },
    "eventPlain": {
      "STATUS_CHANGED": "تغيّرت حالة المشروع",
      "MILESTONE_ACHIEVED": "تحقّق معلم رئيسي",
      "PROGRESS_UPDATED": "حُدّث الإنجاز",
      "BUDGET_APPROVED": "اعتُمدت موازنة",
      "VARIATION_DECIDED": "صدر قرار في أمر تغييري",
      "CLAIM_CERTIFIED": "اعتُمد مستخلص",
      "INVOICE_ISSUED": "صدرت فاتورة",
      "TIME_APPROVED": "اعتُمدت سجلات وقت",
      "MEMBER_ADDED": "انضمام عضو إلى الفريق"
    },
    "variation": {
      "APPROVED": "اعتُمد الأمر التغييري {{label}}",
      "REJECTED": "رُفض الأمر التغييري {{label}}"
    },
    "progressTo": "حُدّث إنجاز {{label}} إلى {{pct}}%",
    "budgetVersion": "اعتُمد الإصدار {{n}} من الموازنة",
    "timeOf": "اعتُمدت سجلات وقت {{person}}: {{duration}}",
    "by": "بواسطة {{name}}",
    "nothing": "لم يتغيّر شيء هذا الأسبوع.",
    "nothingThat": "لم يتغيّر شيء في ذلك الأسبوع.",
    "first": "أول أسبوع مُسجَّل: لا شيء للمقارنة بعد.",
    "noRecord": "لا يوجد سجل لذلك الأسبوع.",
    "failed": "تعذّر تحميل ما تغيّر."
  },
  "burn": {
    "title": "استهلاك الموازنة حسب الفئة",
    "open": "الموازنة والتكاليف",
    "of": "{{used}} من {{budget}}",
    "notInBudget": "خارج الموازنة",
    "meter": "{{category}}: المستهلك من الموازنة",
    "empty": "أضف موازنة لترى التكلفة مقابل الخطة.",
    "failed": "تعذّر تحميل أرقام الموازنة."
  },
  "settings": {
    "dimension": {
      "cost": "التكلفة",
      "costBody": "عندما يسبق الصرف العمل، أو تقارب فئة موازنتها، أو يتقلص هامش الربح.",
      "schedule": "الجدول الزمني",
      "scheduleBody": "عندما تتجاوز المعالم مواعيدها أو يتأخر موعد الانتهاء المتوقع.",
      "billing": "الفوترة والتحصيل",
      "billingBody": "عندما ينتظر عمل منجز الفوترة، أو يتأخر العميل في السداد.",
      "delivery": "التنفيذ",
      "deliveryBody": "عندما يتوقف النشاط في مشروع نشط، أو تبقى مهامه متعثرة، أو لا يُرسِل فريقه وقته.",
      "hygiene": "تنظيم السجلات",
      "hygieneBody": "مستندات تبدو تابعة لهذا المشروع لكنها بلا مشروع.",
      "contract": "العقد",
      "contractBody": "عندما تستحق المحتجزات، أو يقترب ضمان من انتهائه، أو تنتظر المستخلصات والأوامر التغييرية قرار العميل. فقط عند تفعيل التعاقد.",
      "notifications": "الإشعارات",
      "notificationsBody": "يُبلَّغ فريق المشروع بالتنبيه عند ظهوره أو تفاقمه، وتبقى التنبيهات المُحاط بها صامتة حتى تاريخها."
    },
    "unit": {
      "points": "نقطة مئوية",
      "pct": "%",
      "workingDays": "يوم عمل",
      "days": "يوم",
      "perDay": "يوميًا"
    },
    "burnGapPts": {
      "label": "الصرف قبل الإنجاز",
      "hint": "نبّه عندما يسبق الصرف الإنجاز بـ {{points}}، ويصبح حرجًا عند {{twice}}."
    },
    "categoryTolerancePct": {
      "label": "تجاوز فئة لموازنتها",
      "hint": "نبّه عندما يتجاوز المصروف والملتزم به في فئة موازنتها بأكثر من {{pct}}%."
    },
    "categoryNearPct": {
      "label": "اقتراب فئة من موازنتها",
      "hint": "سجّل ملاحظة عندما تستهلك الفئة {{pct}}% من موازنتها."
    },
    "marginDropPts": {
      "label": "تراجع هامش الربح",
      "hint": "نبّه عندما ينخفض هامش الربح المتوقع بأكثر من {{points}} عن الهامش في الموازنة."
    },
    "minProgressForForecastPct": {
      "label": "تبدأ توقعات التكلفة عند",
      "hint": "تحت {{pct}}% من الإنجاز أو {{pct}}% من الموازنة المصروفة تساوي التكلفة النهائية المتوقعة الموازنة (من المبكر التوقع)."
    },
    "eacMethod": {
      "label": "التكلفة النهائية المتوقعة",
      "hint": "كيف تُحسب التكلفة النهائية المتوقعة من الأرقام حتى الآن.",
      "CPI": "بمعدل التكلفة حتى الآن",
      "CPIBody": "الموازنة ÷ كفاءة التكلفة (القيمة المكتسبة لكل ريال مصروف). بقية العمل تكلف بالمعدل نفسه حتى الآن.",
      "REMAINING_AT_BUDGET": "بقية العمل وفق الموازنة",
      "REMAINING_AT_BUDGETBody": "المصروف حتى الآن مع موازنة العمل المتبقي. لا يتكرر التجاوز السابق.",
      "CPI_SPI": "بمعدل التكلفة والوتيرة حتى الآن",
      "CPI_SPIBody": "المصروف حتى الآن مع العمل المتبقي معدّلًا بحسب التكلفة والوتيرة معًا. وهو الأكثر تحفظًا."
    },
    "milestoneCriticalDays": {
      "label": "يصبح المعلم المتأخر حرجًا بعد",
      "hint": "المعلم الذي تجاوز موعده تحذير من أول يوم عمل متأخر، ويصبح حرجًا بعد {{days}}."
    },
    "slipToleranceDays": {
      "label": "تأخر موعد الانتهاء",
      "hint": "نبّه عندما يتأخر موعد الانتهاء المتوقع أكثر من {{days}} عن الموعد المخطط."
    },
    "slipCriticalDays": {
      "label": "تأخر كبير في موعد الانتهاء",
      "hint": "يصبح حرجًا عندما يتأخر أكثر من {{days}}."
    },
    "unbilledGraceDays": {
      "label": "أُنجز ولم يُفوتر",
      "hint": "نبّه عندما يبقى معلم فوترة متحقق بلا فاتورة بعد {{days}}."
    },
    "tmUnbilledDays": {
      "label": "أعمال قابلة للفوترة بالانتظار",
      "hint": "نبّه عندما تنتظر أعمال قابلة للفوترة أكثر من {{days}} قبل فوترتها، وتصبح حرجة عند {{twice}}."
    },
    "arOverdueDays": {
      "label": "تأخر العميل في السداد",
      "hint": "نبّه عندما تتجاوز فاتورة المشروع تاريخ استحقاقها بأكثر من {{days}}."
    },
    "arCriticalDays": {
      "label": "تأخر كبير في السداد",
      "hint": "يصبح حرجًا عندما تتجاوز تاريخ استحقاقها بأكثر من {{days}}."
    },
    "staleDays": {
      "label": "لا نشاط",
      "hint": "نبّه عندما لا يُسجَّل في مشروع نشط إنجاز أو تكلفة أو مهمة لمدة {{days}}."
    },
    "blockedDays": {
      "label": "مهام متعثرة",
      "hint": "نبّه عندما تبقى مهمة في المشروع متعثرة أكثر من {{days}}."
    },
    "overdueTaskDays": {
      "label": "مهام متأخرة",
      "hint": "نبّه عندما تتجاوز مهمة مفتوحة في المشروع موعد استحقاقها بأكثر من {{days}}."
    },
    "timeSubmitPct": {
      "label": "إرسال الوقت",
      "hint": "نبّه عن العضو المخصَّص له جزء من وقته إذا أرسل أقل من {{pct}}% من الساعات المتوقعة للأسبوع الماضي، ويصبح التنبيه تحذيرًا ابتداءً من يوم العمل الثاني في الأسبوع."
    },
    "unassignedMinAmount": {
      "label": "مستندات بلا مشروع",
      "hint": "سجّل ملاحظة عن مستندات عميل المشروع أو مورديه التي لا تحمل مشروعًا، متى بلغت {{amount}}."
    },
    "save": "حفظ إعدادات المؤشرات",
    "saved": "حُفظت إعدادات المؤشرات",
    "conflict": "حفظ شخص آخر هذه الإعدادات أثناء تعديلك. أعد التحميل لترى نسخته.",
    "reload": "إعادة التحميل",
    "range": "أدخل عددًا صحيحًا من 0 إلى {{max}}.",
    "invalid": "راجع القيم المحددة.",
    "rangeFrom": "أدخل عددًا صحيحًا من {{min}} إلى {{max}}.",
    "retentionLeadDays": {
      "label": "اقتراب استحقاق المحتجزات",
      "hint": "ملاحظة بالمحتجزات قبل موعد الإفراج بـ {{days}}، وتحذير عند استحقاقها."
    },
    "bondLeadDays": {
      "label": "اقتراب انتهاء الضمان",
      "hint": "تحذير قبل انتهاء الضمان بـ {{days}}، وحرج بعد انتهائه. يحدد هذا متى يظهر التنبيه على المشروع؛ أما من يُبلَّغ ومتى فيُضبط في المقاولات › التذكير قبل الانتهاء."
    },
    "claimCertDays": {
      "label": "مستخلص بانتظار الاعتماد",
      "hint": "تحذير إذا لم يُعتمد مستخلص مقدَّم بعد {{days}}، وحرج عند {{twice}}."
    },
    "variationPendingDays": {
      "label": "أمر تغييري بانتظار القرار",
      "hint": "ملاحظة بأمر تغييري لم يُبتّ فيه بعد {{days}} من تقديمه."
    },
    "advanceBehindPts": {
      "label": "تأخر استرداد الدفعة المقدمة",
      "hint": "تحذير إذا تأخرت نسبة المسترد من الدفعة المقدمة عن نسبة الإنجاز بأكثر من {{points}}."
    },
    "notifyDailyCap": {
      "label": "التنبيهات لكل شخص يوميًا",
      "hint": "الحد الأقصى لإشعارات التنبيه لكل شخص في اليوم: {{n}}، وتصل البقية معًا في ملخص واحد."
    }
  },
  "trail": {
    "INVOICE": "فاتورة",
    "DEBIT_NOTE": "إشعار مدين",
    "CREDIT_NOTE": "إشعار دائن"
  },
  "bondType": {
    "BID": "ضمان ابتدائي",
    "PERFORMANCE": "ضمان حسن التنفيذ",
    "ADVANCE_PAYMENT": "ضمان الدفعة المقدمة",
    "RETENTION": "ضمان المحتجزات",
    "MAINTENANCE": "ضمان الصيانة"
  },
  "stored": {
    "trigger": "سلامة {{code}}: {{level}}. لماذا؟",
    "notYet": "لم يُفحص بعد",
    "notYetHint": "تُفحص سلامة المشروع كل صباح وبعد كل تغيير عليه.",
    "more": "و{{n}} غيرها",
    "none": "لا تنبيهات.",
    "notMeasured": "يُقاس متى كان المشروع نشطًا وله موازنة معتمدة وخطة مؤرخة.",
    "forecastMargin": "هامش الربح المتوقع",
    "budgetUse": "المستخدم من الموازنة",
    "open": "فتح «تحتاج إلى متابعة»",
    "filterBy": "عرض المشاريع التي عليها هذا التنبيه: {{name}}"
  },
  "trend": {
    "worse": "أسوأ من الأسبوع الماضي: كانت «{{level}}»",
    "better": "أفضل من الأسبوع الماضي: كانت «{{level}}»"
  },
  "ack": {
    "open": "تأجيل التنبيه…",
    "title": "تأجيل هذا التنبيه",
    "body": "تتوقف إشعاراته حتى التاريخ الذي تختاره. ويبقى محسوبًا في سلامة المشروع، وإذا تفاقم ينتهي التأجيل.",
    "note": "السبب",
    "notePlaceholder": "ما الذي يُتخذ بشأنه",
    "noteRequired": "اذكر السبب.",
    "until": "حتى",
    "untilHint": "90 يومًا كحد أقصى: حتى {{date}}.",
    "untilInvalid": "اختر تاريخًا من اليوم حتى {{date}}.",
    "save": "تأجيل التنبيه",
    "saved": "أُجّل التنبيه حتى {{date}}",
    "by": "أجّله {{name}} حتى {{date}}",
    "noteJoin": ": ",
    "end": "إلغاء التأجيل",
    "ended": "أُلغي التأجيل",
    "notActive": "لم يعد هذا التنبيه قائمًا، فلا شيء لتأجيله. أعد تحميل الصفحة.",
    "openNamed": "تأجيل التنبيه: {{title}}",
    "endNamed": "إلغاء التأجيل: {{title}}"
  }
}
